{
  "annotations": "Annotationen",
  "ask": "Im Chat fragen",
  "askAbout": "Im Chat nach {{name}} fragen",
  "chips": "Wird mit Ihrer Nachricht gesendet",
  "documentText": "Dokumenttext",
  "edit": "Bearbeiten",
  "entry": "Durchlauf-Eintrag #{{number}}",
  "newThread": "Neuer Durchlauf daneben",
  "remove": "{{name}} entfernen",
  "selection": "Ausgewählter Text",
  "sentTo": "Im Chat von {{threads}}",
  "show": "Anzeigen",
  "statements": "Aussagen",
  "waiting": "Wartet: kein offener Durchlauf nimmt Nachrichten an",
  "withFork": "Forken Sie diesen Durchlauf, um sie mit Ihrer ersten Nachricht zu senden."
}
